import React from 'react';
import { Cell, Pie, PieChart, Tooltip, ResponsiveContainer } from 'recharts';
import { ChartData } from '../../../interfaces';
import { stringToColor } from '../../../utils';

interface Props {
  data: ChartData[]
}

const ColorPieChartComponent = ({ data }: Props) => {

  const generateData = () => {
    return data.map(item => ({
      name: item.name,
      value: item.value,
      color: stringToColor(item.name)
    }));
  };


  const renderCustomizedLabel = ({ cx, cy, midAngle, innerRadius, outerRadius, percent }: any) => {
    const RADIAN = Math.PI / 180;
    const radius = innerRadius + (outerRadius - innerRadius) * 0.5;
    const x = cx + radius * Math.cos(-(midAngle ?? 0) * RADIAN);
    const y = cy + radius * Math.sin(-(midAngle ?? 0) * RADIAN);

    return (
      <text x={x} y={y} fill="white" textAnchor={x > cx ? 'start' : 'end'} dominantBaseline="central" fontSize={12}>
        {`${((percent ?? 1) * 100).toFixed(0)}%`}
      </text>
    );
  };


  return (
    <ResponsiveContainer width="100%" height={350}>
      <PieChart>
        <Tooltip />
        <Pie
          data={data}
          cx="50%"
          cy="50%"
          innerRadius={80}
          outerRadius={140}
          fill="#8884d8"
          labelLine={false}
          label={renderCustomizedLabel}
          paddingAngle={3}
          dataKey="value"
        >
          {generateData().map((entry) => (
            <Cell style={{ cursor: 'pointer' }} key={`cell-${entry.name}`} fill={entry.color} />
          ))}
        </Pie>
      </PieChart>
    </ResponsiveContainer>
  );
};

export default ColorPieChartComponent;